export default __webpack_public_path__ + "static/media/img-0691-san-marino-full-face.7031472c.png";